export enum ReportPrintOrientation
{
    Portrait = 1,
    Landscape = 2
}